module.exports = __webpack_public_path__ + "static/media/openpay.465b459b.png";